import type { DriveStep } from 'driver.js';

export const doctorCasesSteps: DriveStep[] = [
  {
    element: '[data-tour="doctor-cases-actions"]',
    popover: {
      title: 'Manage Your Cases',
      description:
        'Import cases from other platforms or invite attorneys to submit through your intake form.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-cases-summary"]',
    popover: {
      title: 'Case Summary',
      description: 'Track active and completed cases with at-a-glance revenue totals.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-cases-search"]',
    popover: {
      title: 'Search and Filter',
      description: 'Find cases by name, email, company, or status.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="doctor-cases-table"]',
    popover: {
      title: 'Case Details',
      description: 'Click any case to view records, documents, and billing history.',
      side: 'top',
      align: 'center',
    },
  },
];
